import groq from 'groq'

import { imageFragment } from './image'
import { videoFragment } from './video'

export const blogAuthorFragment = groq`
  name,
  slug,
  photo {
    ${imageFragment}
  },
`

export const blogCategoryFragment = groq`
  name,
  slug,
`

export const blogPostWithoutBodyFragment = groq`
  _id,
  _createdAt,
  _updatedAt,
  date,
  title,
  slug,
  excerpt,
  author->{
    ${blogAuthorFragment}
  },
  categories[]->{
    ${blogCategoryFragment}
  },
  cover {
    type,
    image {
      ${imageFragment}
    },
    video {
      ${videoFragment}
    },
  },
`

export const blogSettingsQuery = groq`
  *[
    _type == "blogSettings" &&
    locale == $locale
  ][0]
`
